import { Component } from '@angular/core';

import { DashboardSystemComponent } from './dashboard-system.component';

@Component({
  selector: 'app-dashboard-system-admin',
  standalone: true,
  imports: [DashboardSystemComponent],
  template: `
    <app-dashboard-system
      [dashboardLayout]="'SYSTEM_ADMIN'"
      [pageTitle]="'System administrator'"
      [pageSubtitle]="'Full platform overview and operations'"
    />
  `,
})
export class DashboardSystemAdminComponent {}
